<template>
    <div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit" v-if="sid=='' || sid==-1">
            <van-field label="门店名称" v-model="form.shopName" name="shopName" placeholder="请选择门店" readonly @click="getshow('shop')" />
            <van-field label="位置" v-model="form.positionBuflName" name="positionBuflName" placeholder="请选择位置" readonly @click="getshow('build')" />
            <van-field label="是否异常" v-model="form.abnormal" name="abnormal">
                <template #input>
                    <van-radio-group class="row-start" v-model="form.abnormal" @change="getchange">
                        <van-radio name="0">是</van-radio>
                        <van-radio name="1">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field label="问题分类" v-model="form.classificationName" name="classificationName" placeholder="请选择问题分类" readonly @click="openPopup('class')" />
            <van-field label="问题标题" v-model="form.feedbackName" name="feedbackName" placeholder="请填写问题标题" />
            <van-field label="问题描述" type="textarea" rows="2" autosize maxlength="50" show-word-limit v-model="form.feedbackDesc" name="feedbackDesc" placeholder="请填写问题描述" />
            <van-field label="问题是否解决" v-model="form.complete" name="complete" v-if="form.abnormal==0">
                <template #input>
                    <van-radio-group class="row-start" v-model="form.complete">
                        <van-radio name="0">否</van-radio>
                        <van-radio name="1">是</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field label="照片" :label-width="60" name="images">
                <template #input>
                    <van-uploader v-model="form.imagestwo" multiple :max-count="3" :after-read="afterRead" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail)"/>
                </template>
            </van-field>
            <van-field label="任务指派" v-model="form.assignedPersonDeptName" name="assignedPersonDeptName" placeholder="请选择任务指派" readonly @click="openPopup('dept')" v-if="form.abnormal==0" />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit" :loading="loading">保存</van-button>
            </div>
        </van-form>
        <div class="flist" v-else>
            <div class="d_box">
                <div class="title">
                    <div class="tit">基本信息</div>
                </div>
                <div class="pa10">
                    <div class="top row-between">
                        <div class="img">
                            <img v-if="form.imgList && form.imgList.length>0" :src="form.imgList[0].url"/>
                        </div>
                        <div class="text">
                            <div>{{form.feedbackCode}}</div>
                            <div>{{form.shopName}}</div>
                            <div>楼栋：{{form.buildName}}</div>
                            <div>楼层：{{form.floorName}}</div>
                            <div>位置名称：{{form.position}}</div>
                            <div>问题标题：{{form.feedbackName}}</div>
                        </div>
                    </div>
                </div>
                <van-cell-group>
                    <van-cell class="wval" title="位置编码" :value="form.pointSid" />
                    <van-cell class="wval" title="位置描述" :value="form.position" />
                    <div class="row-start wrap">
                        <van-cell title="任务类型" value="问题反馈" />
                        <van-cell title="是否异常" :value="form.abnormal==0?'是':form.abnormal==1?'否':''" />
                        <van-cell title="问题状态" :value="form.feedbackStatus==0?'待解决':form.feedbackStatus==1?'解决中':form.feedbackStatus==2?'待验收':form.feedbackStatus==3?'已完成':form.feedbackStatus==4?'日常记录':''" />
                        <van-cell title="问题是否解决" class="wla" :value="form.complete==0?'未解决':form.complete==1?'已解决':''" />
                        
                    </div>
                    <van-cell class="wval" title="任务指派" :value="form.assignDeptName" />
                    <van-cell class="wval" title="当前流转" :value="form.circulationDeptName" />
                    <van-cell class="wval" title="问题分类" :value="form.classificationName" />
                    <van-cell class="wval" title="问题描述" :value="form.feedbackDesc" />
                    <van-cell class="wval" title="照片">
                       <van-uploader v-model="form.imgList" disabled :deletable="false"/>
                    </van-cell>
                    <van-cell class="wval" title="提交人" :value="form.createdUserName" />
                    <van-cell class="wval" title="提交时间" :value="form.createdTime" />
                </van-cell-group>
            </div>
            <div class="d_box">
                <div class="title">
                    <div class="tit">问题分配</div>
                </div>
                <div class="pa10" v-if="(form.createdUser==user || user==form.circulationUser) && form.feedbackStatus<3">
                    <div class="bai">
                        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goallocate">
                            <van-field label="问题分配" v-model="form.assigneddeptPersonName" name="assignedPersonName" placeholder="请选择问题分配" readonly @click="openPopup('dept')" :rules="[{ required: true, message: '请选择问题分配' }]"/>
                            <van-field label="预计完成时间" v-model="form.estimatedCompletionTime" readonly name="estimatedCompletionTime" placeholder="请选择预计完成时间" :rules="[{ required: true, message: '请选择预计完成时间' }]" @click="show = true" />
                            <van-field label="备注" type="textarea" rows="2" autosize maxlength="50" show-word-limit v-model="form.memo" name="memo" placeholder="请填写备注" />
                            <div style="margin: 16px;">
                                <van-button round block type="info" native-type="submit" :loading="loading">确认分配</van-button>
                            </div>
                        </van-form>
                    </div>
                </div>
                
                <div class="pa10">
                    <van-list
                    v-model="loadingshow"
                    :finished="finished"
                    finished-text="没有更多了">
                        <table :border="1" cellspacing="0" width="100%" id="tableId">
                            <tr>
                                <td class="short">操作人</td>
                                <td>操作人部门</td>
                                <td>操作内容</td>
                                <td>操作对象</td>
                                <td>操作对象部门</td>
                                <td>操作时间</td>
                                <td>备注</td> 
                            </tr>
                            <tr v-for="(item,index) in form.allocationList" :key="index">
                                <td class="short">{{ item.operatorName }}</td>
                                <td>{{ item.operatorDeptName }}</td>
                                <td>{{ item.operateDesc }}</td>
                                <td>{{ item.assignedPersonName }}</td>
                                <td>{{ item.assignedPersonDeptName }}</td>
                                <td>{{ item.operationTime }}</td>
                                <td>{{ item.memo }}</td>
                            </tr>
                        </table>
                    </van-list>
                </div>
            </div>
            <div class="d_box">
                <div class="title row-between">
                    <div class="tit">问题接受</div>
                    <van-button size="small" type="info" @click="getaccept()" v-if="form.circulationUser==user && (form.allocationList.length==0 || (form.allocationList.length>0 && form.allocationList[form.allocationList.length-1].operator!=user))">接受任务</van-button>
                </div>                
                <div class="pa10">
                    <van-list
                    v-model="loadingshow"
                    :finished="finished"
                    finished-text="没有更多了">
                        <table :border="1" cellspacing="0" width="100%" id="tableId">
                            <tr>
                                <td class="short">操作人</td>
                                <td>操作人部门</td>
                                <td>操作时间</td>
                                <td>操作备注</td> 
                            </tr>
                            <tr v-for="(item,index) in form.allocationList" :key="index">
                                <td class="short">{{ item.operatorName }}</td>
                                <td>{{ item.operatorDeptName }}</td>
                                <td>{{ item.operationTime }}</td>
                                <td>{{ item.memo }}</td>
                            </tr>
                        </table>
                    </van-list>
                </div>
                <van-cell-group v-if="form.complete!=1">
                    <div class="pa10">
                        <div class="bai">
                            <van-form :show-error-message="false" :scroll-to-error="true" @submit="gethandlebefour">
                                <van-field label="问题是否解决" v-model="formtwo.complete" name="complete" :rules="[{ required: true, message: '请选择问题是否解决' }]">
                                    <template #input>
                                        <van-radio-group class="row-start" v-model="formtwo.complete">
                                            <van-radio name="0">异常</van-radio>
                                            <van-radio name="1">正常</van-radio>
                                        </van-radio-group>
                                    </template>
                                </van-field>
                                <van-field label-width="2.5em" label="备注" type="textarea" rows="2" autosize maxlength="50" show-word-limit v-model="formtwo.memo" name="memo" placeholder="请填写备注" />
                                <div style="margin: 16px;">
                                    <van-button round block type="info" native-type="submit" :loading="loading">确认</van-button>
                                </div>
                            </van-form>
                        </div>
                        
                    </div>
                </van-cell-group>
            </div>
            <div class="d_box">
                <div class="title">问题完成情况</div>
                <van-cell-group>
                    <van-cell class="wval2" title="问题分配人员" :value="form.completeList.length>0?form.completeList[form.completeList.length-1].operatorName:''" />
                    <van-cell class="wval2" title="问题是否解决" :value="form.completeList.length>0?(form.completeList[form.completeList.length-1].complete==1?'已解决':'未解决'):''" />
                    <van-cell class="wval2" title="备注" :value="form.completeList.length>0?form.completeList[form.completeList.length-1].memo:''" />
                </van-cell-group>
                <div class="pa10">
                    <van-list
                    v-model="loadingshow"
                    :finished="finished"
                    finished-text="没有更多了">
                        <table :border="1" cellspacing="0" width="100%" id="tableId">
                            <tr>
                                <td class="short">操作人</td>
                                <td>操作人部门</td>
                                <td>操作时间</td>
                                <td>操作备注</td> 
                            </tr>
                            <tr v-for="(item,index) in form.completeList" :key="index">
                                <td class="short">{{ item.operatorName }}</td>
                                <td>{{ item.operatorDeptName }}</td>
                                <td>{{ item.operationTime }}</td>
                                <td>{{ item.memo }}</td>
                            </tr>
                        </table>
                    </van-list>
                    <!-- v-if="button.includes('btn_milogcheck')" -->
                    <div style="margin-top:20px;text-align: center;" v-if="form.completeList.length>0 && form.completeList[form.completeList.length-1].complete==1 && form.checkUserName!='' && (user==form.createdUser || mstore==user)">
                        <van-button size="small" round type="info" @click="getys()">
                            <span style="display:inline-block;width:30px"></span>
                            验收
                            <span style="display:inline-block;width:30px"></span>
                        </van-button>
                    </div>
                    
                </div>
            </div>
            <div class="d_box" v-if="form.completeList.length>0 && form.completeList[form.completeList.length-1].complete==1 && form.checkUserName!=''">
                <div class="title">验收记录</div>
                <van-cell-group>
                    <van-cell class="wval" title="验收人" :value="form.checkUserName" />
                    <van-cell class="wval" title="验收时间" :value="form.checkTime" />
                    <van-cell class="wval" title="照片">
                        <van-uploader v-model="form.checkimg" disabled :deletable="false"/>
                    </van-cell>
                    <van-cell class="wval" title="验收备注" :value="form.checkMemo" />
                </van-cell-group>
            </div>
        </div>
        <van-action-sheet v-model="showshop" close-on-click-overlay="false">
            <!-- <van-search v-model="keyword" show-action placeholder="请输入搜索关键词" @search="onSearch" @cancel="onCancel" /> -->
            <div class="title row-between">
                <div class="red">取消</div>
                <div>{{formtype=='shop'?'门店':'位置'}}</div>
                <div class="lan" @click="getqr()">确认</div>
            </div>
            <!-- <div class="txt" v-if="formtype!='shop'">
                <span>{{buildName}}</span>
                <span>{{floorName}}</span>
                <span>{{position}}</span>
            </div> -->
            <div class="scroll">
                <van-cell-group v-if="formtype=='shop'">
                    <van-cell v-for="(item,index) in showlist" :key="index" :title="item.text" @click="getval(item)">
                        <template slot="title">
                            <span :style="{color:(item.value==shopSid?'#1989fa':'#7d7e80')}">{{item.text}}</span>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group v-if="formtype!='shop'">
                    <van-cell v-for="(item,index) in showlist" :key="index" :title="item.pointName || item.floorName || item.buildName" @click="getval(item)">
                        <div>
                            <van-icon size="1.5em" name="checked" :color="(item.sid==buildSid && formtype=='build') || (item.sid==floorSid && formtype=='floor') || (item.sid==pointSid && formtype=='point')?'#1989fa':'#7d7e80'" />
                            <van-icon v-if="formtype!='point'" style="margin-left: 10px;" size="1.5em" name="https://static.xunchen.work/image/2025/09/03/1756880585724790.png" @click.stop="getnext(item)" />
                            <!-- <van-icon size="1em" name="https://static.xunchen.work/image/2025/09/03/1756880585724790.png" />   -->
                        </div>
                    </van-cell>
                </van-cell-group>
            </div>
        </van-action-sheet>
        <van-popup v-model="showPopup" position="bottom" :close-on-click-overlay="false">
            <div class="title row-between">
                <div class="red" @click="close1()">取消</div>
                <div>{{formtype=='dept'?'任务指派':'问题分类'}}</div>
                <div class="lan"></div>
            </div>
             <div class="scroll">
                <van-cell-group>
                    <van-cell v-for="(item,index) in showclass" :key="index" :title="item.classificationName || (formtype=='dept'?item.deptName:item.userName)" @click="getclassval(item)">
                        <div v-if="formtype=='dept' || (item.childList && item.childList.length>0)">
                            <van-icon v-if="formtype=='dept'" size="1.5em" name="checked" :color="item.dingDeptId==form.assignedPersonDingDeptId?'#1989fa':'#7d7e80'" />
                            <van-icon v-if="(item.childList && item.childList.length>0 && formtype!='dept') || (formtype=='dept' && form.circulationDeptName!='' && form.circulationDeptName==item.deptName && form.circulationUser==user)" style="margin-left: 10px;" size="1.5em" name="https://static.xunchen.work/image/2025/09/03/1756880585724790.png" @click.stop="getnextdept(item)" />
                            <!-- <van-icon size="1em" name="https://static.xunchen.work/image/2025/09/03/1756880585724790.png" />   -->
                        </div>
                    </van-cell>
                </van-cell-group>
             </div>
        </van-popup>
        <van-popup v-model="showding" position="center" :close-on-click-overlay="false" :round="true" :closeable="true" :style="{ width: '90%' }">
            <div style="height:40px;"></div>
                <div class="tit2">问题已解决，确认验收</div>
                <van-form>
                    <van-field label="照片" name="照片" label-width="40px">
                        <template #input>
                            <van-uploader v-model="imgUrltwo" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,'imgUrl')" :after-read="(file, detail) => afterRead(file, detail,'imgUrl')" />
                        </template>
                    </van-field>
                    <van-cell title="备注"/>
                    <van-field class="hbj" v-model="memo" rows="4" autosize name="备注" label="" type="textarea" show-word-limit placeholder="备注"/>
                    <div class="ma16 row-between">
                        <van-button round block type="info" color="#3332B5" @click="closeshowding()">取消</van-button>
                        <div class="w10"></div>
                        <van-button round block type="info" color="#3332B5" @click="Confirmys()">确认</van-button>
                    </div>
                </van-form>
        </van-popup>
        <van-calendar color="#3332B5" v-model="show" @confirm="onConfirm" />
    </div>
     
</template>

<script>
import wx from 'weixin-js-sdk'
import { Dialog } from 'vant';
import * as Minio from 'minio';
import axios from "axios";
import * as imageConversion from 'image-conversion';
export default {
    name: 'Issuelog',
    data () {
        return {
            showding:false,
            memo:'',
            imgUrltwo:[],
            imgUrl:'',
            form:{
                group:4,
                shopSid:'',
                shopName:'',
                position:'',
                pointSid:'',
                floorSid:'',
                feedbackName:'',
                feedbackDesc:'',
                complete:'',
                classificationSid:'',
                classificationName:'',
                buildSid:'',
                assignDingDeptId:'',
                assignDeptName:'',
                abnormal:'',
                images:[],
                positionBuflName:'',
                assignedPersonName:'',
                assignedPerson:'',
                assignedPersonDeptName:'',
                assignedPersonDingDeptId:'',
                assigneddeptPersonName:'',
                checkList:[],
                completeList:[],
                allocationList:[],
                imagestwo:[],
                imgUrl:'',
            },
            formtwo:{
                complete:'',
                memo:'',
            },
            loading:false,
            showshop:false,
            show:false,
            showlist:[],
            shoplist:[],
            buildlist:[],
            floorlist:[],
            classlist:[],
            pointlist:[],
            showclass:[],
            buildSid:'',
            buildName:'',
            floorSid:'',
            floorName:'',
            pointSid:'',
            position:'',
            formtype:'build',
            type:4,
            loadingshow:false,
            finished:true,
            minioClient: null,
            shopName:'',
            shopSid:'',
            showPopup:false,
            bucketName:'',
            userlist:[],
            button:this.$route.params.button.split(','),
            token:this.$route.params.token,
            sid:this.$route.params.sid,
            user:this.$route.params.uid,
            mstore:'',
        }
    },
    created(){
       if(this.sid=='' || this.sid==-1){
        this.getinit()
        this.getclass()
       }else{
        this.getlist()
       }
    },
    methods:{
        closeshowding(){
            this.showding=false
            this.memo=''
            this.imgUrltwo=[]
            this.imgUrl=''
        },
        getys(){
            this.memo=''
            this.imgUrltwo=[]
            this.imgUrl=''
            this.showding=true
        },
        Confirmys(){
            let that=this;
            let form={
                feedbackSid:that.sid,
                imgUrl:that.imgUrl,
                memo:that.memo,
                operator:that.user,
                operatorName:that.$route.params.uname,
            }
            that.$axios.post(process.env.API_HOST+"pms/app/work/order/check",form,{
                headers:{
                    userTicket:that.token,
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.$toast.success('验收成功');
                    that.getlist()
                    // that.shoplist = res.data.data.shopList || []
                }else{
                    that.$toast(res.data.message)
                }
            }).catch((error) =>{
                
            });
        },
        //接受任务
        getaccept(){
            let that=this;
            let form = new FormData();
            form.append('sid', that.sid)
            that.$axios.post(process.env.API_HOST+"pms/app/work/order/accept",form,{
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    userTicket:that.token,
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.getlist()
                    // that.shoplist = res.data.data.shopList || []
                }else{
                    that.$toast(res.data.message)
                }
            }).catch((error) =>{
            });
        },
        //处理问题
        gethandlebefour(){
            let name=this.formtwo.complete==1?'问题已解决，点击完成本次问题反馈，等待验收':'问题尚未解决，添加一条备注记录'
            Dialog.confirm({
                title: '提示',
                message: name,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.gethandle()
            }).catch(() => {
                
            });
        },
        gethandle(){
            let that=this;
            that.loading=true
            let form={
                complete:that.formtwo.complete,
                memo:that.formtwo.memo,
                feedbackSid:that.sid,
            }
            that.$axios.post(process.env.API_HOST+"pms/app/work/order/handle",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                that.loading=false
                if(res.data.state==200){
                    that.getlist()
                    that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            }).catch((error) =>{
                that.loading=false
            })
        },
        getlist(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"pms/app/work/order?sid="+that.sid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.form=res.data.data
                    that.form.checkList=that.form.checkList==null?[]:that.form.checkList
                    that.form.allocationList=that.form.allocationList==null?[]:that.form.allocationList
                    that.form.completeList=that.form.completeList==null?[]:that.form.completeList
                    that.form.assignedPersonDeptName=that.form.assignedPersonDeptName || ''
                    that.form.assignedPersonDingDeptId=that.form.assignedPersonDingDeptId || ''
                    that.form.assignedPersonName=that.form.assignedPersonName || ''
                    that.form.estimatedCompletionTime=that.form.estimatedCompletionTime || ''
                    that.form.assigneddeptPersonName=that.form.assigneddeptPersonName || ''
                    let imglist=[]
                    let checkimg=[]
                    that.$axios.get(process.env.API_HOST+"sysmanager/applets/os-config/shop?shopSid="+that.form.shopSid+'&osType='+that.type,{
                        headers:{
                            userTicket:that.token
                        }
                    }).then((res2) => {
                        if(res2.data.state==200){
                            if(!res2.data.data){
                                that.$toast('请先在后台配置图片存储信息')
                            }else{
                                that.bucketName=res2.data.data.bucketName || ''
                                that.minioClient = new Minio.Client({
                                    // endPoint: res2.data.data.pathUrl,
                                    // port: 80,
                                    // useSSL: false,
                                    endPoint: res2.data.data.pathUrl,
                                    port: 443,
                                    useSSL: true,
                                    accessKey: res2.data.data.accessKey,
                                    secretKey: res2.data.data.secretKey
                                });
                                if(res.data.data.imgList.length>0){
                                    res.data.data.imgList.filter((otem, i) => {
                                        if(otem.imgUrl!=''){
                                            that.minioClient.presignedUrl('GET',that.bucketName, otem.imgUrl, function (err, presignedUrl) {
                                            const file = {
                                                url: presignedUrl
                                            }
                                            if(otem.imgType==1){
                                                 imglist.push(file)
                                            }else{
                                                checkimg.push(file)
                                            }
                                           
                                            // console.log("图片地址地址",presignedUrl)
                                        }) 
                                        }
                                        
                                    }) 
                                    that.form.imgList=imglist
                                    that.form.checkimg=checkimg
                                }
                            }
                        }else{
                            that.$toast(res2,data.message)
                        }
                    })
                    // that.form.completetwo=that.form.completetwo || ''
                    // that.form.completememo=that.form.completememo || ''
                    that.getuser()
                    // that.shoplist = res.data.data.shopList || []
                }
            }).catch((error) =>{
            });
        },
        formatDate(date) {
            return `${date.getFullYear()}-${ (date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        },
        onConfirm(date){
            this.form.estimatedCompletionTime = this.formatDate(date);
            this.show=false
        },
        onClick1({ columnIndex, index, item }){
            console.log('clickItem-----', { columnIndex, index, item });
        },
        onComfirm1(arr) {
            console.log(arr)
            this.$toast(arr.map(item => item.item.content).join(','));
        },
        openPopup(type) {
            if(this.form.shopSid==''){
                this.$toast('请先选择门店')
                return
            }
            this.formtype=type
            this.showclass=type=='class'?JSON.parse(JSON.stringify(this.classlist)):JSON.parse(JSON.stringify(this.userlist))
            this.showPopup = true;
        },
        close1() {
            this.showPopup = false;
        },
        getclassval(item){
            console.log(this.formtype,this.sid!='' && this.sid!=-1)
            if(this.formtype=='dept'){
                if(this.sid!='' && this.sid!=-1){
                    this.form.assignedPersonDeptName=item.deptName
                    this.form.assignedPersonDingDeptId=item.dingDeptId
                    this.form.assigneddeptPersonName=item.deptName
                    this.form.assignedPersonName=item.deptName
                }else{
                    this.form.assignDeptName=item.deptName
                    this.form.assignDingDeptId=item.dingDeptId
                    this.form.assignedPersonName=item.deptName
                    this.form.assignedPersonDeptName=item.deptName
                }
                // this.form.assignedPersonName=item.userName
                // this.form.assignedPerson=item.userSid
                this.close1()
                return
            }
            if(this.formtype=='user'){
                this.form.assignedPersonName=item.userName
                this.form.assignedPerson=item.userSid
                this.form.assigneddeptPersonName=item.userName
                this.form.assignedPersonName=item.userName
                this.close1()
                return
            }
            if(item.childList.length>0){
                this.showclass=JSON.parse(JSON.stringify(item.childList))
            }else{
                this.form.classificationSid=item.sid
                this.form.classificationName=item.classificationName
                this.close1()
            }
            
        },
        getnextdept(item){
            let that=this;
            if(that.formtype=='class'){
                this.showclass=JSON.parse(JSON.stringify(item.childList))
                return
            }
            that.formtype='user'
            console.log(that.formtype)
            that.form.assignedPersonDeptName=item.deptName
            that.form.assignedPersonDingDeptId=item.dingDeptId
            that.$axios.post(process.env.API_HOST+"sysmanager/vue/dingtalk/dept/user?deptSid="+that.form.assignedPersonDingDeptId,[that.form.shopSid],{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    this.showclass=JSON.parse(JSON.stringify(res.data.data))
                    // that.shoplist = res.data.data.shopList || []
                }
            }).catch((error) =>{
            });
        },
        getinit(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"maindata/vue/contract/info/filterItemList?shopSid="+that.form.shopSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.shoplist = res.data.data.shopList || []
                }
            }).catch((error) =>{
            });
        },
        getshop(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"sysmanager/applets/os-config/shop?shopSid="+that.form.shopSid+'&osType='+that.type,{
                headers:{
                    userTicket:that.token
                }
            }).then((res2) => {
                if(res2.data.state==200){
                    if(!res2.data.data){
                    that.$toast('请先在后台配置图片存储信息')
                    }else{
                    that.bucketName=res2.data.data.bucketName || ''
                    that.minioClient = new Minio.Client({
                        // endPoint: res2.data.data.pathUrl,
                        // port: 80,
                        // useSSL: false,
                        endPoint: res2.data.data.pathUrl,
                        port: 443,
                        useSSL: true,
                        accessKey: res2.data.data.accessKey,
                        secretKey: res2.data.data.secretKey
                    });
                    }
                }else{
                    that.$toast(res2,data.message)
                }
            })
        },
        getuser(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"sysmanager/applets/user/dept/leader/shop?shopSid="+that.form.shopSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    let list=[]
                    if(res.data.data.length>0){
                        res.data.data.filter((item, i) => {
                            if(item.deptName.split('（').length==1){
                                that.mstore=item.userSid
                            }
                            list.push({
                                deptName:item.deptName,
                                dingDeptId:item.dingDeptId,
                                name:item.deptName.split('（')[0],
                                userSid:item.userSid,
                                userName:item.userName,
                                sid:item.sid,
                            })
                        })
                    }
                    that.userlist = list || []
                }
            }).catch((error) =>{
            });
        },
        showContent(){

        },
        onSearch(){

        },
        onCancel(){

        },
        getchange(val){            
            if(val==1){
                this.form.assignDeptName=''
                this.form.assignDingDeptId=''
                this.form.assignedPersonName=''
                this.form.assignedPersonDeptName=''
                this.form.complete=0
            }else{
                this.form.complete=''
            }
        },
        getshow(type){
            if(type=='build' && this.form.shopSid==''){
                this.$toast('请先选择门店')
                return
            }
            this.showlist=type=='shop'?JSON.parse(JSON.stringify(this.shoplist)):JSON.parse(JSON.stringify(this.buildlist))
            this.formtype=type
            this.showshop=true
        },
        getval(item){
            if(this.formtype=='shop'){
                let that=this;
                that.shopName=item.name
                that.shopSid=item.value
                that.$axios.get(process.env.API_HOST+"sysmanager/applets/os-config/shop?shopSid="+that.shopSid+'&osType='+that.type,{
                        headers:{
                            userTicket:that.token
                        }
                    }).then((res2) => {
                        if(res2.data.state==200){
                            if(!res2.data.data){
                                that.$toast('请先在后台配置图片存储信息')
                            }else{
                                that.bucketName=res2.data.data.bucketName || ''
                                that.minioClient = new Minio.Client({
                                    // endPoint: res2.data.data.pathUrl,
                                    // port: 80,
                                    // useSSL: false,
                                    endPoint: res2.data.data.pathUrl,
                                    port: 443,
                                    useSSL: true,
                                    accessKey: res2.data.data.accessKey,
                                    secretKey: res2.data.data.secretKey
                                });
                            }
                        }else{
                            that.$toast(res2,data.message)
                        }
                    })
            }else if(this.formtype=='build'){
                this.buildSid=item.sid
                this.buildName=item.buildName
            }else if(this.formtype=='floor'){
                this.floorSid=item.sid
                this.floorName=item.floorName
            }else if(this.formtype=='point'){
                this.pointSid=item.sid
                this.position=item.pointName
            }
        },
        getnext(item){
            if(this.formtype=='build'){
                this.buildSid=item.sid
                this.buildName=item.buildName
                this.floorSid=''
                this.formtype='floor'
                this.getfloor()
            }else if(this.formtype=='floor'){
                this.floorSid=item.sid
                this.floorName=item.floorName
                this.formtype='point'
                this.getpoint()
            }else if(this.formtype=='point'){
                this.pointSid=item.sid
                this.position=item.pointName
            }
            console.log("下一级")
        },
        getqr(){
            if(this.formtype=='shop'){
                this.form.shopName=this.shopName
                this.form.shopSid=this.shopSid
                this.showshop=false
                this.getshop()
                this.getuser()
                this.getbuild()
                return
            }
            this.form.buildSid=this.buildSid
            this.form.floorSid=this.floorSid
            this.form.buildName=this.buildName
            this.form.floorName=this.floorName
            this.form.pointSid=this.pointSid
            this.form.position=this.position
            console.log(this.position)
            let floorName=this.floorName!=''?'/'+this.floorName:''
            let position=this.position!=''?'/'+this.position:''
            this.form.positionBuflName=this.buildName+floorName+position
            this.showshop=false
        },
        getbuild(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"pms/app/work/order/build/list?sid="+that.form.shopSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.buildlist=res.data.data || []
                    that.showlist=JSON.parse(JSON.stringify(this.buildlist))
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        getfloor(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"pms/app/work/order/floor/list?sid="+that.buildSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.floorlist=res.data.data || []
                    this.showlist=JSON.parse(JSON.stringify(this.floorlist))
                    console.log(res.data)
                    // that.getlist()
                    // that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        getpoint(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"pms/vue/patrol/point/list?periodicType=4&shopSid="+that.form.shopSid+'&buildSid='+that.buildSid+'&floorSid='+that.floorSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.pointlist=res.data.data || []
                    that.showlist=JSON.parse(JSON.stringify(this.pointlist))
                    console.log(res.data)
                    // that.getlist()
                    // that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        getclass(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"pms/app/work/order/classification/three?group=4",{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.classlist=res.data.data || []
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        goSubmit(){
            let that=this
            that.loading=true
            that.$axios.post(process.env.API_HOST+"pms/app/work/order",that.form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                that.loading=false
                if(res.data.state==200){
                    // that.getlist()
                    that.$toast.success('提交成功');
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            wx.miniProgram.reLaunch({
                                url:'/pages/index/index?type=Issuelog',// 指定跳转至小程序页面的路径
                                success: (res) => {
                                    // alert(res)
                                    console.log(res);   // 页面跳转成功的回调函数
                                },
                                fail: (err) => {
                                    console.log(err);   // 页面跳转失败的回调函数
                                }
                            });
                        }
                    });
                }else{
                    that.$toast.fail(res.data.message);
                }
            }).catch((error) =>{
                that.loading=false
            })
        },
        goallocate(){
            let that=this
            that.loading=true
            let form={
                assignedPersonDeptName:that.form.assignedPersonDeptName,
                assignedPersonDingDeptId:that.form.assignedPersonDingDeptId,
                assignedPersonName:that.form.assignedPersonName,
                assignedPerson:that.form.assignedPerson || '',
                estimatedCompletionTime:that.form.estimatedCompletionTime,
                feedbackSid:that.sid,
                memo:that.form.memo
            }
            that.$axios.post(process.env.API_HOST+"pms/app/work/order/allocation",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                that.loading=false
                if(res.data.state==200){
                    that.getlist()
                    that.$toast.success('分配成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            }).catch((error) =>{
                that.loading=false
            })
        },
        dateNumber(sp=''){
            const date = new Date()
            const  year = date.getFullYear()
            const  month = date.getMonth()>9?date.getMonth()+1:'0'+(date.getMonth()+1)
            const  day = date.getDate();
            return year.toString()+month+day.toString()
        },
        getUUID () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })
        },
        beforeRead(file){
        if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
            this.$toast('图片格式不正确');
            return false;
        }
        return new Promise((resolve) => {
            imageConversion.compressAccurately(file, 400).then(res => {
                let res2= new File([res], file.name, {
                    type: res.type,
                    lastModified: Date.now()
                });
                this.selectedFile=res2
                resolve(res);
            });
        })
        }, 
        afterRead(files, detail,type) {
            let that=this;
            files.status = "uploading";
            files.message = "上传中...";
            const suffixType =that.selectedFile&&that.selectedFile.name?that.selectedFile.name.substr(that.selectedFile.name.lastIndexOf('.')):''
            const UrlName = `${that.dateNumber()}/${that.getUUID()}${suffixType}`
            // console.log('selectedFile',that.selectedFile.name)
            if (!that.selectedFile) return;
            that.minioClient.presignedPutObject(that.bucketName, UrlName, 24 * 60 * 60, function (err, presignedUrl) {
                axios.put(presignedUrl, that.selectedFile, {
                    headers: {'Content-Type': that.selectedFile.type},
                    timeout: 1000 * 60 * 30,
                    onUploadProgress: function (progressEvent) {
                        // that.getFipstwo(UrlName)
                        /** 返回文件当前上传的进度* */
                        console.log({loaded:progressEvent.loaded,total:progressEvent.total,proNum:Number((progressEvent.loaded / progressEvent.total * 100).toFixed(0))})
                        
                    }
                }).then((res) => {
                    console.log(res)
                    files.status = "";
                    that.$toast('上传成功')
                    if(type=='imgUrl'){
                        that.imgUrl=UrlName
                    }else{
                        that.form.images.push(UrlName)
                    }
                }).catch((error) => {
                    if(type=='imgUrl'){
                        that.imgUrltwo=[]
                    }else{
                        that.form.images=[]
                    }
                    that.$toast('上传失败')
                })
            })
        },
        deleteImg(file, detail) {
            this.form.imagestwo.splice(detail.index, 1)
            this.form.images.splice(detail.index, 1)
        },
    }
}
</script>

<style scoped>
>>> .van-list{
    overflow-x: scroll;
    overflow-y: hidden;
}
table {
  font-size: 14px;
  border-color: #929292;
  border-collapse: collapse;
  white-space: nowrap;
  text-align: center;
  word-wrap: break-word;
  word-break: break-all;
}
table .name {
    background-color: #f3f3f3;
    position: sticky;
    z-index: 1;
    left: 0;
    padding: unset;
}
table td {
    padding: 5px 10px;
    background: #fff;
}
table tr:nth-child(1) td:nth-child(1) {
    background: #fff;
}
.short {
    position: sticky;
    z-index: 1;
    left: 0;
    background: #fff;
}
.short tr:nth-child(1) {
    background: #fff;
}
tr:nth-child(1) {
    background: #fff;
}
tr:nth-child(1) td:nth-child(2) {
    background: #fff;
}

.tdline{
    width: 100px;
}
.th-row{
    height:30px;
    line-height:30px;
    padding:0px 12px;
    background:#fd7273;
}
.td-row{
    height:30px;
    line-height:30px;
    padding:0px 12px;
}
.row-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.row-start{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.row-start >>>.van-cell{
    width: 50% !important;
}
.wrap{
    flex-wrap: wrap;
}
.title{
    padding: 10px 16px 5px;
    font-size: 16px;
}
.red{
    color: #f44;
}
.lan{
    color: #1989fa;
}
.scroll{
    width: 100%;
    max-height: 60vh;
    min-height: 30vh;
    overflow-y: auto;
}
.flist{
    /* width: 100; */
    margin: 0.2rem auto 0;
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0.2rem 0.4rem 0;
}
.d_box{
    width: 100%;
    margin-top: 0.2rem;
    border-radius: 0.2rem;
    box-sizing: border-box;
    background: #E8EBEF;
    overflow: hidden;
}
.d_box .title{
    position: relative;
    font-size: 0.42rem;
    font-weight: bold;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 0.3rem 0.5rem;
}
.d_box .title::after{
    position: absolute;
    content: "";
    width: 0.12rem;
    height: 0.5rem;
    background: #6236FF;
    left: 0.2rem;
    top: 50%;
    margin-top: -0.25rem;
    border-radius: 0.18rem;
}
.d_box .pa10{
    padding: 10px;
}
.d_box .bai{
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    padding-top: 10px;
}
.d_box .bai >>> .van-cell{
  background: #fff;
}
.d_box >>> .van-cell{
    padding: 5px 16px;
}
.d_box >>> .van-cell__value{
    text-align: left;
}
.d_box >>> .van-cell-group,.d_box >>> .van-cell{
  background: #E8EBEF;
}
.d_box >>> .van-field__label,.d_box >>> .van-field__control{
    color: #303133;
}
>>>.van-cell__value{
    color: #323233;
}
.wval >>>.van-cell__value{
    flex: 3.4 !important;
}
.wval2 >>>.van-cell__value{
    flex: 2 !important;
}
.wla >>>.van-cell__title{
    flex: 2;
}
.top{
    background: #3332B5;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 10px;
}
.top .img{
    width: 120px;
    height: 120px;
    border-radius: 5px;
    overflow: hidden;
    background: #d7d7d7;
}
.top .img img{
    width: 100%;
    height: 100%;
}
.text{
    flex: 1;
    color: #fff;
    font-size: 14px;
    line-height: 160%;
    margin-left: 10px;
}
>>>.van-list__finished-text{
    display: none;
}
.hbj >>> .van-field__body .van-field__control{
    background: #fafafa;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 5px;
}
.mauto{
    text-align: center;
    box-sizing: border-box;
    padding: 0 16px;
}
.ma16{
    margin: 16px;
}
.w10{
    width: 20px;
}
.tit2{
    box-sizing: border-box;
    padding: 0 16px 16px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/view/Issuelog.vue